import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'epay-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent implements OnInit {
  pagetitle = 'Contact Us';

  constructor() { }

  ngOnInit() {
  }

}
